var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJ4Clogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 126.87358 92.565533",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    style: {
      display: "inline"
    },
    transform: "translate(104.06826,-71.446499)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ececec",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.264583px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m -52.465818,77.97992 c 1.900051,-3.518725 1.166276,-4.679614 -0.01372,-5.64729 -1.179997,-0.967676 -2.806339,-1.741982 -6.700354,1.055905 -3.894014,2.797887 -12.908165,12.117609 -19.53176,18.385516 -6.623595,6.267908 -12.282904,10.958629 -16.955551,14.976219 -4.672647,4.01758 -8.358767,7.36215 -8.400697,10.76975 -0.0419,3.40759 3.55992,6.87847 8.232775,10.81215 4.672851,3.93368 10.416231,8.32983 15.275085,12.56822 4.858853,4.23839 8.833356,8.3191 12.807801,12.39975 3.974445,4.08065 8.789515,9.02439 11.137549,10.17932 2.348034,1.15493 3.910232,0.24731 5.130181,-0.97264 1.219948,-1.21995 2.097777,-2.75236 0.130468,-6.21497 -1.967308,-3.46261 -9.018325,-11.36376 -14.950088,-18.0107 -5.931764,-6.64694 -11.863507,-13.29385 -11.884681,-20.15114 -0.02117,-6.85729 5.868616,-13.92489 11.579888,-21.044655 5.711272,-7.119766 12.243056,-15.58671 14.143106,-19.105435 z",
    id: "path32943"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ececec",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.264583px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m -28.797127,77.97992 c -1.900051,-3.518722 -1.166274,-4.679613 0.01373,-5.647291 1.18,-0.967678 2.806339,-1.74198 6.70035,1.055908 3.894011,2.797888 12.9081623,12.117608 19.5317564,18.385515 6.623594,6.267907 12.2829086,10.958638 16.9555566,14.976228 4.672649,4.01758 8.358767,7.36215 8.400692,10.76975 0.04192,3.40759 -3.559919,6.87847 -8.23277,10.81215 -4.672852,3.93368 -10.4162286,8.32982 -15.27508478,12.56821 -4.85885612,4.23839 -8.83335842,8.3191 -12.80780222,12.39975 -3.974444,4.08065 -8.789514,9.02439 -11.137548,10.17932 -2.348033,1.15493 -3.910232,0.2473 -5.13018,-0.97264 -1.219948,-1.21995 -2.097777,-2.75236 -0.130468,-6.21497 1.967308,-3.46261 9.018324,-11.36376 14.950086,-18.0107 5.9317628,-6.64693 11.863507,-13.29384 11.8846841,-20.15113 0.021177,-6.85729 -5.8686122,-13.92489 -11.5798871,-21.044664 -5.711274,-7.11977 -12.243059,-15.586715 -14.143111,-19.105436 z",
    id: "path38433"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a2ca0",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.108981px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m -56.474239,118.02345 c -1.726727,1.66408 -3.354129,1.26594 -4.113464,0.27809 -0.759335,-0.98785 -1.43724,-3.54315 -0.134178,-5.84453 1.303062,-2.30138 5.587209,-6.34397 8.095149,-8.87699 2.507939,-2.53301 3.850888,-4.133155 4.948508,-5.800478 1.09762,-1.667322 1.949721,-3.401607 2.975259,-5.207865 1.025537,-1.806258 2.224658,-3.684713 3.497065,-3.682162 1.272407,0.0026 2.6177,1.885507 3.890982,4.325877 1.273282,2.440371 2.473823,5.436539 4.419653,7.669358 1.94583,2.23282 4.635863,3.70138 6.769206,5.09678 2.133343,1.3954 3.909782,2.88536 4.389742,4.6135 0.47996,1.72815 -0.06368,4.75016 -1.197153,5.85218 -1.133473,1.10203 -3.363576,0.52984 -4.734552,-0.77603 -1.370976,-1.30588 -3.683728,-5.06138 -5.895909,-8.22014 -2.212181,-3.15876 -4.781742,-6.46443 -7.406417,-6.42054 -2.624674,0.0439 -5.3044,3.43747 -8.016164,7.1467 -2.711763,3.70923 -5.761,8.18217 -7.487727,9.84625 z",
    id: "path38439"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#00a843",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.264999,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect42664",
    width: 4.8191104,
    height: 34.26923,
    x: -48.075726,
    y: 110.40864,
    ry: 2.4095552
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fe0066",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.264999,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect42688",
    width: 4.2279801,
    height: 13.882919,
    x: -41.396347,
    y: 104.68983,
    ry: 2.1139901
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fe6601",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.264999,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect42690",
    width: 4.3541884,
    height: 7.1307721,
    x: -41.459446,
    y: 121.72797,
    ry: 2.1139891
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#3635c6",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.293105,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect42692",
    width: 4.6066051,
    height: 4.6066051,
    x: -41.585655,
    y: 132.26636,
    ry: 2.3033025
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJ4Clogo);
export default __webpack_public_path__ + "static/media/j4clogo.2404ba8d.svg";
export { ForwardRef as ReactComponent };